// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#hotel-view {\n  width: 100%;\n  height: 100%;\n}\n.background {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  bottom: 38px;\n  background: url(\"https://images.habbo.com/c_images/reception/easter20_background_left.png\") bottom left no-repeat, url(\"https://images.habbo.com/c_images/reception/background_right_easter2016.png\") bottom right no-repeat, url(\"https://images.habbo.com/c_images/reception/easter20_background_gradient.png\") 100% 100%;\n}\n", ""]);
// Exports
module.exports = exports;
